export class ConstantsRouting {
    static readonly BEGRIFFSERLAEUTERUNGEN_BAUKOST: string = "begriffserlaeuterungen-baukost";
    static readonly UEBER_BAUKOST: string = "ueber-baukost"; 
}
  
  